import { connect } from 'react-redux';
import { searchBooking } from '../redux/actions/bookingSearch';
import Login from '../components/login/Login';

const mapStateToProps = ({ bookingSearch, config, arrivalTime }, { secretCode }) => ({
  isFetching: bookingSearch.isFetching,
  errorMessage: bookingSearch.errorMessage,
  booking: bookingSearch.booking,
  resortCode: bookingSearch.siteCode,
  arrivalDate: bookingSearch.arrivalDate,
  isLoginDisabled: config.REACT_APP_DISABLED_LOGIN_ALL === 'true',
  arrivalTimeSlots: arrivalTime.arrivalTimeSlots,
  secretCode,
});

const mapDispatchToProps = dispatch => ({
  login: (resId, siteCode, lastName, arrivalDate, rawBookingRef, secretCode) => dispatch(
    searchBooking({ resId, siteCode, lastName, arrivalDate, rawBookingRef, secretCode }),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
